function startCountdown(timeLeft, elementId) {
    let timeLeftElement = document.getElementById('timeLeft');
    let clickableElement = document.getElementById(elementId);
    let interval = setInterval(() => {

        if (timeLeftElement.offsetParent === null) {
            clearInterval(interval);
            return;
        }
        
        timeLeft--;
        if (timeLeft === 0) {
            clickableElement.click();
            clearInterval(interval);
        }
        timeLeftElement.textContent = timeLeft;
    }, 1000);
}

export { startCountdown };